import * as getters from '../../vuex/getters';
import store from '../../vuex/store';
import _ from 'lodash';

export default {
  viewContent(name) {
    try {
      //console.log(`google viewContent ${name}`);
      //ga('set', 'page', `${name}`);
      //gtag('send', 'pageview', name);
    } catch (e) {
      console.log(e);
    }
  },
  boot() {
    try {
      const user = getters.user(store.state);
      if (_.isObject(user)) {
        gtag('set', {'user_id': user.email}); // Set the user ID using signed-in user_id.
      }
    } catch (e) {
      console.log(e);
    }
    return Promise.resolve();
  }
}
